/* CUSTOM_FREIGHTHUB_BY_CLAUDE (Freight Hub H2, Ryan 2026-10-15) - Freight Hub -> Book Re-nudge, the JS half.
   Moved VERBATIM from assets/rep-settings-agent-panels.js when every freight setting left Settings for the
   Freight Hub (decision F3, Freight-Hub/FREIGHT-HUB-PLANNER.md). Markup: snippets/freight-hub-book-renudge.liquid, which
   also loads this file. Same routes, same fields, same save bodies as before the move.
   showMsg / hideMsg / vslaEsc are copies of that file's IIFE-local helpers. */
(function() {
  'use strict';
  function showMsg(el, text, type) {
    if (!el) return;
    el.textContent = text;
    el.className = 'rep-settings__message rep-settings__message--visible rep-settings__message--' + type;
  }
  function hideMsg(el) {
    if (!el) return;
    el.className = 'rep-settings__message';
  }
function vslaEsc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function(c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function init() {
    if (!window.RepPortal || !window.RepPortal.API) return;
/* CUSTOM_BOOKAWAIT_BY_CLAUDE (AIOPS 5b77bea20be6, Ryan 2026-09-21) - the Book re-nudge: the kill switch,
   two dials, the last run, and a dry run that answers while the rail is off. Nothing here sends. */
var bkwEnabled = document.getElementById('settings-bookawait-enabled');
var bkwDays = document.getElementById('settings-bookawait-days');
var bkwNudges = document.getElementById('settings-bookawait-nudges');
var bkwRocket = document.getElementById('settings-bookawait-rocket'); // CUSTOM_ROCKETLOAD_BY_CLAUDE (ONYX 5d9774f80e55)
var bkwBtn = document.getElementById('settings-bookawait-btn');
var bkwPreviewBtn = document.getElementById('settings-bookawait-preview-btn');
var bkwPreview = document.getElementById('settings-bookawait-preview');
var bkwMsg = document.getElementById('settings-bookawait-msg');
var bkwStatus = document.getElementById('settings-bookawait-status');

function bkwApply(c) {
  if (!c) return;
  if (bkwEnabled) bkwEnabled.checked = c.enabled !== false;
  if (bkwDays) bkwDays.value = (c.businessDays == null ? 1 : c.businessDays);
  if (bkwNudges) bkwNudges.value = (c.maxNudges == null ? 2 : c.maxNudges);
  if (bkwRocket) bkwRocket.checked = c.rocketWatch === true; // CUSTOM_ROCKETLOAD_BY_CLAUDE - absent reads OFF
}
/* The last run is printed even when it did nothing: a quiet hour is normal here, and it is also what a
   dead cron looks like. This line is the only thing that tells them apart. */
function bkwRenderLast(d) {
  if (!bkwStatus) return;
  var last = d && d.lastRun;
  if (!last) { bkwStatus.textContent = 'It has not run yet.'; return; }
  var when = '';
  try { when = new Date(last.at).toLocaleString(); } catch (_) { when = String(last.at || ''); }
  bkwStatus.textContent = 'Last run ' + when + ': ' + (last.jobs || 0) + ' hand-off(s) being watched, '
    + (last.woke || 0) + ' nudge(s) asked of the Order Desk'
    + (last.dropped ? ', ' + last.dropped + ' finished and dropped' : '')
    + (last.deferred ? ' - ' + last.deferred + ' left for the next pass' : '') + '.';
}

if (bkwBtn && bkwEnabled) {
  (async function loadBkw() {
    try {
      var data = await window.RepPortal.API.get('/admin/book-awaiting-config');
      bkwApply(data.config || {});
      bkwRenderLast(data);
    } catch (e) {
      showMsg(bkwMsg, 'Could not load the current settings - reload before saving.', 'error');
      if (bkwStatus) bkwStatus.textContent = 'Could not load the last run.';
    }
  })();

  bkwBtn.addEventListener('click', async function() {
    hideMsg(bkwMsg);
    var d = parseInt(bkwDays.value, 10);
    var n = parseInt(bkwNudges.value, 10);
    if (!isFinite(d) || d < 1 || d > 10) { showMsg(bkwMsg, 'Ask after is a whole number of business days from 1 to 10.', 'error'); return; }
    if (!isFinite(n) || n < 1 || n > 5) { showMsg(bkwMsg, 'How many nudges is a whole number from 1 to 5.', 'error'); return; }
    bkwBtn.disabled = true;
    var orig = bkwBtn.textContent;
    bkwBtn.textContent = 'Saving...';
    try {
      var res = await window.RepPortal.API.post('/admin/book-awaiting-config', { enabled: !!bkwEnabled.checked, businessDays: d, maxNudges: n, rocketWatch: !!(bkwRocket && bkwRocket.checked) });
      if (res && res.error) throw new Error(res.error);
      bkwApply(res.config || {});
      bkwRenderLast(res);
      showMsg(bkwMsg, res.config && res.config.enabled !== false
        ? 'Saved - a Book hand-off nobody has acted on after ' + res.config.businessDays + ' business day(s) wakes the Order Desk to nudge you, up to ' + res.config.maxNudges + ' time(s).'
        : 'Saved - the re-nudge is off. Hand-offs are still recorded, so turning it on later picks them up.', 'success');
    } catch (e) {
      showMsg(bkwMsg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally { bkwBtn.disabled = false; bkwBtn.textContent = orig; }
  });
}

if (bkwPreviewBtn && bkwPreview) {
  bkwPreviewBtn.addEventListener('click', async function() {
    hideMsg(bkwMsg);
    bkwPreviewBtn.disabled = true;
    var orig = bkwPreviewBtn.textContent;
    bkwPreviewBtn.textContent = 'Checking...';
    try {
      var d = await window.RepPortal.API.get('/admin/book-awaiting');
      var run = (d && d.run) || {};
      var rows = run.wakeRows || [];
      bkwPreview.innerHTML = rows.length
        ? '<ul style="margin: 0 0 8px; padding-left: 20px; font-size: 13px;">' + rows.map(function(r) {
            return '<li style="margin: 0 0 2px;">' + vslaEsc(r.ref) + (r.loadNumber ? ' - Load ' + vslaEsc(r.loadNumber) : '')
              + ' <span style="color: var(--rq-text-secondary);">(handed off ' + vslaEsc(String(r.handoffAt || '').slice(0, 10))
              + ', nudge ' + vslaEsc(String(r.nudge || 1)) + ' of ' + vslaEsc(String(r.of || 2)) + ')</span></li>';
          }).join('') + '</ul>'
        : '';
      bkwPreview.style.display = rows.length ? '' : 'none';
      showMsg(bkwMsg, rows.length
        ? 'Right now it would wake the Order Desk about ' + rows.length + ' hand-off(s). Nothing was asked.'
        : (run.jobs
            ? 'All ' + run.jobs + ' hand-off(s) are either not due yet or already booked. Nothing would happen.'
            : 'No Book hand-offs are being watched. The next one the Order Desk emails you appears here.'), 'success');
      try { bkwRenderLast(await window.RepPortal.API.get('/admin/book-awaiting-config')); } catch (_) { /* the preview is the answer here */ }
    } catch (e) {
      showMsg(bkwMsg, 'Could not run the check: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally { bkwPreviewBtn.disabled = false; bkwPreviewBtn.textContent = orig; }
  });
}
/* END CUSTOM_BOOKAWAIT_BY_CLAUDE */
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
/* END CUSTOM_FREIGHTHUB_BY_CLAUDE */
